import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const UsageTrackerContext = /*#__PURE__*/createContext(undefined);
const StandaloneUsageTrackerContext = /*#__PURE__*/createContext(undefined);
export function UsageTrackerProvider({
  children,
  standaloneTracker: _standaloneTracker,
  tracker
}) {
  const standaloneTracker = _standaloneTracker || (tracker ? tracker.clone({
    standalone: true
  }) : undefined);
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: tracker,
    children: /*#__PURE__*/_jsx(StandaloneUsageTrackerContext.Provider, {
      value: standaloneTracker,
      children: children
    })
  });
}
export function createMockUsageTracker({
  clone,
  getConfig,
  setProperties,
  track
}) {
  return {
    clone: clone || jasmine.createSpy('clone').and.callFake(() => createMockUsageTracker({
      clone,
      getConfig,
      setProperties,
      track
    })),
    setProperties: setProperties !== null && setProperties !== void 0 ? setProperties : jasmine.createSpy('setProperties'),
    getConfig: getConfig !== null && getConfig !== void 0 ? getConfig : jasmine.createSpy('getConfig'),
    track: track !== null && track !== void 0 ? track : jasmine.createSpy('track')
  };
}
export function MockUsageTrackerProvider({
  children,
  cloneSpy,
  getConfigSpy,
  setPropertiesSpy,
  trackSpy
}) {
  const mockTracker = useMemo(() => {
    return createMockUsageTracker({
      clone: cloneSpy,
      getConfig: getConfigSpy,
      setProperties: setPropertiesSpy,
      track: trackSpy
    });
  }, [cloneSpy, getConfigSpy, setPropertiesSpy, trackSpy]);
  return /*#__PURE__*/_jsx(UsageTrackerProvider, {
    standaloneTracker: mockTracker,
    tracker: mockTracker,
    children: children
  });
}
export function useUsageTracker() {
  const tracker = useContext(UsageTrackerContext);
  if (!tracker) {
    throw new Error('[useUsageTracker] Tracker not found. Please use UsageTrackerProvider to provide a tracker.');
  }
  return tracker;
}
export function useStandaloneUsageTracker(beacon = false) {
  const tracker = useContext(StandaloneUsageTrackerContext);
  if (!tracker) {
    throw new Error('[useStandaloneUsageTracker] Tracker not found. Please use UsageTrackerProvider to provide a tracker.');
  }
  return beacon ? tracker.clone({
    isBeforeUnload: true
  }) : tracker;
}